export const DEFAULT_NAVIGATION_PREFERENCES = Object.freeze({
  tasks: true,
  reminders: true,
  routines: true,
  clients: true,
  services: true,
  history: true,
  reports: true,
  accounting: true,
});

export const NAVIGATION_PRESETS = Object.freeze({
  invoicing: { tasks: false, reminders: false, routines: false, clients: true, services: false, history: false, reports: true, accounting: false },
  operations: { tasks: true, reminders: true, routines: true, clients: true, services: true, history: true, reports: true, accounting: false },
  accounting: { ...DEFAULT_NAVIGATION_PREFERENCES },
});

export const normalizeNavigationPreferences = (value = {}) => Object.fromEntries(
  Object.entries(DEFAULT_NAVIGATION_PREFERENCES).map(([key, fallback]) => [key, typeof value?.[key] === "boolean" ? value[key] : fallback]),
);

const storageKey = (organizationId, profileId) => `invoice-studio.navigation.${organizationId || "workspace"}.${profileId || "member"}`;

export const readNavigationPreferences = (organizationId, profileId, storage) => {
  try {
    const resolvedStorage = storage === undefined ? (typeof window === "undefined" ? null : window.localStorage) : storage;
    if (!resolvedStorage) return normalizeNavigationPreferences();
    return normalizeNavigationPreferences(JSON.parse(resolvedStorage.getItem(storageKey(organizationId, profileId)) || "{}"));
  } catch {
    return normalizeNavigationPreferences();
  }
};

export const writeNavigationPreferences = (organizationId, profileId, preferences, storage = typeof window === "undefined" ? null : window.localStorage) => {
  const normalized = normalizeNavigationPreferences(preferences);
  if (!storage) throw new Error("Navigation preferences storage is unavailable.");
  storage.setItem(storageKey(organizationId, profileId), JSON.stringify(normalized));
  return normalized;
};
